import { MenuOutlined } from '@ant-design/icons'
import { UserResponseDto } from '@headbox-ui/auth-hook/dist/useGlobalAuth'
import { colours } from '@headbox-ui/themes'
import { Avatar, Button, Card, Drawer, Menu, Typography } from 'antd'
import React, { useState, FC } from 'react'
import * as s from './styles'
import MenuItem from '../MenuItem'
import { useActorSession, useTopNav, useSubNav, Link } from '../../BusinessLogic'

const { brick } = colours
const { Text } = Typography

const WelcomeCard: FC<{ user: UserResponseDto }> = ({ user }): JSX.Element => {
  if (user === undefined) {
    return null
  }

  return (
    <>
      <Card
        bordered={false}
        style={{ borderRadius: 0 }}
        bodyStyle={{ padding: 16 }}
      >
        <Avatar src={user.avatar} size='large' style={{
          backgroundColor: brick[600],
          color: brick[100],
          cursor: 'pointer',
          letterSpacing: 1,
          marginRight: 10
        }}>
          {user.firstName}
        </Avatar>

        <Text>Hi {user.firstName} 👋</Text>
      </Card>
    </>
  )
}

const NavMenu: FC<{
  links: Link[]
}> = ({ links }): JSX.Element => {
  if (links === null) {
    return null
  }

  const selectedKey = links.findIndex(({ href }) => window.location.href.includes(href)).toString()

  return (
    <Menu mode='vertical' selectedKeys={[selectedKey]}>
      <Menu.Divider />
      {links.map(MenuItem)}
    </Menu>
  )
}

const UserMenu: FC<{
  links: Link[]
  logout: {
    onClick?: () => void
    title: string
  }
}> = ({ links, logout }): JSX.Element => {
  if (links === undefined) {
    return null
  }

  return (
    <Menu mode='vertical'>
      <Menu.Divider />
      {links.map(MenuItem)}
      <Menu.Item>
        <a className='logout' onClick={logout.onClick}>
          {logout.title}
        </a>
      </Menu.Item>
    </Menu>
  )
}

const SideNav: FC = (): JSX.Element => {
  const subNavLinks = useSubNav()
  const topNavLinks = useTopNav()
  const session = useActorSession()
  const [visible, setVisible] = useState<boolean>(false)

  if (topNavLinks === null && session === null) {
    return null
  }

  return (
    <>
      <Button className="sideMenu"onClick={() => setVisible(!visible)} icon={<MenuOutlined />} style={{ border: 'none' }} />
      <Drawer
        onClose={() => setVisible(false)}
        bodyStyle={s.drawer}
        placement='left'
        getContainer={'header-app-root'}
        {...{ visible }}>
        <>
          <WelcomeCard user={session?.user} />
          <NavMenu links={topNavLinks} />
          <NavMenu links={subNavLinks} />
          <UserMenu links={session?.links} logout={session?.logout} />
        </>
      </Drawer>
    </>
  )
}

export default SideNav
